import Cookies from "universal-cookie";
import { getAdmin } from "../api/User";

const cookies = new Cookies();

const GetAdmin = async () => {
  const token = await cookies.get("jwt-auth");
  if (token) {
    const res = await getAdmin(token);
    return res.data;
  } else {
    return "empty";
  }
};

export default GetAdmin;
